export default __webpack_public_path__ + "static/media/abhinav_bansal_o.1b6d76c9.png";